import React from "react";
import { Column, Sheet, Text } from "@amzn/meridian";
import PillButton from "src/components/UI/PillButton";
import "./LeaveInspectionSheet.scss";

interface LeaveInspectionSheetProps {
  open: boolean;
  /** Leave the inspection and go back to the dashboard. */
  onLeave: () => void;
  /** Dismiss the sheet and stay on the inspection. */
  onStay: () => void;
}

const LeaveInspectionSheet: React.FC<LeaveInspectionSheetProps> = ({
  open,
  onLeave,
  onStay,
}) => {
  return (
    <Sheet type="overlay" side="bottom" open={open} onClose={onStay}>
      <Column spacing="400" spacingInset="500">
        <Text type="h300">Are you sure you want to leave this inspection?</Text>

        <Text type="b200" color="secondary">
          Your inspection will be interrupted, and the current progress will be
          saved as an In Progress inspection.
        </Text>

        {/* Stacked full-width so the longer labels stay on a single line. */}
        <Column className="leave-inspection-sheet__actions" spacing="300">
          <PillButton text="STAY ON INSPECTION" color="primary" onClick={onStay} />
          <PillButton text="GO TO DASHBOARD" color="outline" onClick={onLeave} />
        </Column>
      </Column>
    </Sheet>
  );
};

export default LeaveInspectionSheet;
